import { useTranslation } from 'next-i18next'
import { addMinutes, differenceInMinutes } from 'date-fns'

import { isEmptyOrNull } from '@/utils'
import { parseDate } from '@/utils/date'
import embeddedLinkGenerators from '@/utils/video-embedded-links'
import { show as showExternalLinkModal } from '@/components/external-link-modal'
import { show as showVideoLightBox } from '@/components/video-light-box'
import { VideoLinkPlayer } from '@/components/video-player'

const videoHasProcessed = timestamp => {
  const PROCESSING_MINUTES = 5
  const UTCOffset = new Date().getTimezoneOffset()
  const currentUTC = addMinutes(new Date(), UTCOffset)
  const hasProcessed =
    differenceInMinutes(new Date(currentUTC), new Date(parseDate(timestamp))) >=
    PROCESSING_MINUTES
  return hasProcessed
}

const useTourLinks = ({ listingLinks, unitVideos }) => {
  const { t } = useTranslation()

  const hasVideoFile = unitVideos.length > 0
  const videoProcessed = hasVideoFile
    ? videoHasProcessed(unitVideos[0].created_at)
    : false

  const videoTourLink = listingLinks['tour_video']
  const showVideoLink =
    (hasVideoFile && videoProcessed) || !isEmptyOrNull(videoTourLink?.link_url)

  const threeDVideoLink = listingLinks['tour_3d']
  const show3dTourLink = !isEmptyOrNull(threeDVideoLink?.link_url)

  const playbackUrl = videoTourLink?.link_url //only 2d videos play internally, don't need to check other links
    ? embeddedLinkGenerators[videoTourLink.link_service](videoTourLink.link_url)
    : ''

  const handleVideoClick = () => {
    if (hasVideoFile) {
      showVideoLightBox({
        videoLocation: unitVideos[0].location,
        controls: true,
        autoPlay: true
      })
    } else if (playbackUrl) {
      showVideoLightBox({
        videoLocation: playbackUrl,
        controls: true,
        autoPlay: true,
        PlayerComponent: VideoLinkPlayer
      })
    }
  }

  const handle3DTourClick = () => {
    showExternalLinkModal({
      url: threeDVideoLink.link_url, //only 3d videos open externally, don't need to use other link
      message: t(
        'b.listing.view.video_link.external_website.message',
        'Please note you will be redirected to a third-party website.'
      )
    })
  }

  return { handleVideoClick, handle3DTourClick, showVideoLink, show3dTourLink }
}

export default useTourLinks
